<template>
  <label class="checkbox-wrapper">
    <div class="checkbox" :class="{'checkbox--round': round}">
      <input type="checkbox" :checked="isChecked" :value="value" @change="updateInput" />
      <div class="v"></div>
    </div>
    <span v-text="label"/>
  </label>
</template>

<script>
export default {
  name: 'NewCheckbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: { type: String },
    modelValue: { default: "" },
    label: { type: String, required: true},
    trueValue: { default: true },
    falseValue: { default: false },
    round: { type: Boolean, default: false}
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      this.$emit('set', this.value)
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
}
</script>

<style lang="scss">
.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  cursor: pointer;
  .checkbox {
    margin-right: 8px;
  }
}
.checkbox {
  display: flex;
  position: relative;
  overflow: hidden;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 3px;

  input {
    @include inputHide;
  }

  .v {
    width: 100%;
    height: 100%;
    border: 1px solid #d0d0d0;
    box-sizing: border-box;
    border-radius: 5px;
    transition: all 0.25s;
    background: transparent no-repeat center center;
  }

  input:checked + .v {
    background-color: $primary;
    background-image: url('~@/assets/icons/checkbox-w.svg');
    border: none;
  }

  &--round {
    .v {
      border-radius: 50%;
    }
  }
}
</style>
